<span matBadge="{{ badgeContent }}" [matBadgeHidden]="isHidden" [matBadgeColor]="badgeColor">
    <ng-content></ng-content>
</span>
